// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 在这里定义你的全局状态
        websocket: null,
        deviceDetails: {},
    },
    mutations: {
        // 在这里定义你的状态修改函数（同步操作）
        setWebSocket(state, websocket) {
            state.websocket = websocket;
        }
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js